// extracted by mini-css-extract-plugin
export var bgImage = "SparkCaseStudy-module--bg-image--3ffac";
export var container = "SparkCaseStudy-module--container--5b751";
export var content = "SparkCaseStudy-module--content--c0a06";
export var video = "SparkCaseStudy-module--video--6ebfc";
export var videoContainer = "SparkCaseStudy-module--video-container--6d1ba";